export enum MODES {
  COMPLETE = 'complete',
  LINK = 'link',
  LOGIN = 'login',
  SIGNUP = 'signup',
}

export enum THIRD_PARTY_AUTH_METHODS {
  APPLE = 'apple',
  FACEBOOK = 'facebook',
  GOOGLE = 'google',
}

export const AUTH_METHODS_NO_DISABLED_BUTTON = [THIRD_PARTY_AUTH_METHODS.FACEBOOK] as const;
